<template>
  <BModal
    :id="id"
    :visible="show"
    scrollable
    size="lg"
    hide-header
    style="padding: 0px !important"
    :footer-class="successfullyRegistered ? 'd-none' : ''"
    header-class="bg-white border-0"
    @hide="$emit('hide')"
  >
    <div v-if="!successfullyRegistered">
      <div class="row">
        <div class="col-md-6 text-center register-sidebar">
          <div class="feature-top">Create Your FREE</div>
          <div class="feature-bottom">Buyer Account Today!</div>
          <img src="/img/onboard/buyer-reg-from-storefront.png" class="img-fluid mt-4" />
          <div class="w-100 p-3">
            <div class="text-left mt-3">
              <ul class="features">
                <li class="feature">Manage Your Orders</li>
                <li class="feature">Access Vendor Menus 24/7</li>
                <li class="feature">Chat with Your Seller</li>
                <li class="feature">Source for Products or Discover New Vendors</li>
                <li class="feature">It’s Totally Free and Awesome!</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 text-center">
          <img
            :src="industry == 'cannabis' ? '/img/logos/apex-logo.png' : '/img/logos/bushel-logo.png'"
            :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
            width="200px"
            class="mb-3 mt-4"
          />
          <div class="alert alert-light-primary text-center text-sm">
            Please make sure your company doesn't already have an {{ appName }} account. <br />If so, ask to be invited as a user instead.
          </div>
          <div v-if="showCheckIfIsBuyerOnOrderWarning" class="alert alert-light-primary text-center text-sm">
            Please only register here if you are the buyer on this order. Otherwise go <a href="/">here</a>.
          </div>
          <div @keyup.enter="register">
            <div class="container">
              <BushelTextInputMaterial
                :value="formData.name"
                type="text"
                name="registerName"
                :thin="true"
                :error="submitted && !formData.name"
                :label-active="'Name'"
                autocomplete="off"
                @input="(name) => (formData.name = name)"
              />
              <BushelTextInputMaterial
                :value="formData.email"
                type="email"
                name="registerEmail"
                :thin="true"
                :error="submitted && !validateEmail(formData.email)"
                :label-active="'Email'"
                autocomplete="off"
                @input="(email) => (formData.email = email)"
              />
              <BushelFlagMaterial
                :value="formData.phone"
                :default-country="formData.country"
                name="registerPhone"
                type="tel"
                :thin="true"
                :error="submitted && !formData.phone"
                :label-active="'Phone'"
                @input="(phone) => (formData.phone = phone)"
                @country-selected="onSelectCountry"
              />
              <div class="row mb-0">
                <div class="col pr-1">
                  <div class="form-group material-form">
                    <BushelTextInputMaterial
                      :value="formData.password"
                      thin
                      name="Password"
                      :error="submitted && formData.password.length < 8"
                      :error-text="'8 char min, letters, mixedCase, numbers, symbols'"
                      :type="showPassword ? 'text' : 'password'"
                      :label-active="'Password'"
                      autocomplete="off"
                      @input="(password) => (formData.password = password)"
                    />
                  </div>
                </div>
                <div class="col">
                  <div class="form-group material-form">
                    <BushelTextInputMaterial
                      :value="formData.passwordConfirm"
                      thin
                      name="PasswordConfirm"
                      :error="submitted && (!formData.passwordConfirm || formData.passwordConfirm != formData.password)"
                      :error-text="'must match password'"
                      :type="showPassword ? 'text' : 'password'"
                      :label-active="'Confirm'"
                      :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
                      autocomplete="off"
                      @input="(password) => (formData.passwordConfirm = password)"
                      @icon-clicked="showPassword = !showPassword"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col ml-0 pl-0">
                  <p class="text-sm">8 char min, letters, mixedcase, numbers, and symbols</p>
                </div>
              </div>
              <div class="row">
                <div class="col" style="margin-top: -7px; margin-left: -13px">
                  <div class="custom-checkbox">
                    <input id="acceptTerms" v-model="formData.acceptTerms" name="acceptTerms" type="checkbox" />
                    <label for="acceptTerms" :class="{ checkboxLabelError: submitted && !formData.acceptTerms }">
                      <span class="checkbox-box" dusk="register-checkbox" />
                      <div style="margin-top: -10px">
                        <span class="small">I Accept The</span>
                      </div>
                    </label>
                  </div>
                  <span
                    class="text-success small text-nowrap clickable"
                    style="position: absolute; top: 19px; left: 39px"
                    @click="showTerms = !showTerms"
                  >
                    Terms And Conditions
                  </span>
                </div>
              </div>
              <div v-if="error && errorMessage" class="row mt-3">
                <div class="col">
                  <div class="alert alert-warning text-center">
                    <p>{{ errorMessage }}</p>
                    <BushelBtn variant="primary" @click="viewLogin"> Sign In Instead? </BushelBtn>
                  </div>
                </div>
              </div>
            </div>
            <BModal v-model="showTerms" max-width="500" scrollable @hide="showTerms = false">
              <template #modal-title> Terms And Conditions </template>
              <Terms />
              <template #modal-footer>
                <BushelBtn variant="danger" ripple-color="danger" flat @click="disagree"> Disagree </BushelBtn>
                <BushelBtn variant="success" ripple-color="success" flat @click="agree"> Agree </BushelBtn>
              </template>
            </BModal>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Checkmark :title="'Success'" :subtext="registrationSuccessMessage" />
    </div>
    <template #modal-footer>
      <BushelBtn
        v-if="!successfullyRegistered"
        variant="secondary"
        ripple-color="secondary"
        :disabled="submitted && workingOnRegister"
        flat
        @click="$emit('hide')"
      >
        Cancel
      </BushelBtn>
      <BushelBtn
        v-if="!successfullyRegistered"
        variant="success"
        ripple-color="success"
        :disabled="submitted && workingOnRegister"
        :loading="submitted && workingOnRegister"
        @click="register"
      >
        Sign Up
      </BushelBtn>
    </template>
  </BModal>
</template>

<script>
import { mapActions } from "vuex";
import Terms from "@/components/common/Terms.vue";
import BushelFlagMaterial from "@/components/common/forms/BushelFlagMaterial.vue";
import BushelTextInputMaterial from "@/components/common/forms/BushelTextInputMaterial.vue";
import Checkmark from "@/components/common/Checkmark.vue";
import { navTo, validateEmail } from "@/services/helpers";

export default {
  components: {
    Terms,
    BushelFlagMaterial,
    BushelTextInputMaterial,
    Checkmark,
  },
  props: {
    show: { type: Boolean, required: true },
    id: { type: String, default: "sneakyRegisterModal" },
    buyerUuid: { type: String, required: true },
    invitationEmail: { type: String, required: true },
    showCheckIfIsBuyerOnOrderWarning: { type: Boolean, default: false },
    registrationSuccessMessage: { type: String, required: true },
  },
  emits: ["registered", "viewLogin", "hide"],
  data() {
    return {
      appName: APP_NAME,
      industry: APP_INDUSTRY,
      showTerms: false,
      submitted: false,
      workingOnRegister: false,
      showPassword: false,
      successfullyRegistered: false,
      error: false,
      formData: {
        email: this.invitationEmail ? this.invitationEmail : null,
        password: "",
        passwordConfirm: "",
        token: "",
        name: "",
        phone: null,
        valid: false,
        country: "",
        countryCode: "",
        errorMessage: null,
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    navTo,
    validateEmail,
    ...mapActions({
      registerAction: "auth/register",
      fetchSelf: "auth/fetchSelf",
    }),
    register() {
      this.submitted = true;
      if (
        this.validateEmail(this.formData.email) &&
        this.formData.phone &&
        this.formData.password.length >= 8 &&
        this.formData.passwordConfirm == this.formData.password &&
        this.formData.acceptTerms &&
        this.formData.name
      ) {
        const payload = {
          email: this.formData.email,
          name: this.formData.name,
          phone: this.formData.phone,
          phone_country: this.formData.country,
          country_code: this.formData.countryCode,
          buyer_invitation: this.buyerUuid,
          password: this.formData.password,
          subscription: "buyer",
        };
        this.workingOnRegister = true;

        this.registerAction(payload).then((response) => {
          this.workingOnRegister = false;
          this.submitted = false;
          if (response == "success") {
            this.fetchSelf();
            this.successfullyRegistered = true;
            const that = this;
            setTimeout(() => {
              that.$emit("registered");
            }, 3000);
          } else {
            this.error = true;
            if (response == "email taken") {
              this.errorMessage = "Sorry this email is already in use.";
            } else if (response && response.length && (typeof response === "string" || response instanceof String)) {
              this.errorMessage = response;
            } else {
              this.errorMessage = "Something went wrong. If you already have an account, please login or reset your password instead";
            }
          }
        });
      }
    },
    toggleCheckbox() {
      if (this.formData.acceptTerms == true) {
        this.disagree();
      } else {
        this.agree();
      }
    },
    onSelectCountry({ name, iso2, dialCode }) {
      this.formData.country = iso2;
      this.formData.countryCode = dialCode;
    },
    agree() {
      this.showTerms = false;
      this.formData.acceptTerms = true;
    },
    disagree() {
      this.showTerms = false;
      this.formData.acceptTerms = false;
    },
    viewLogin() {
      this.$emit("hide");
      this.$emit("viewLogin");
    },
  },
};
</script>

<style scoped lang="scss">
.grey-text {
  color: #a7b1c0;
}
.grey-box {
  padding: 10px;
  border: 1px solid #dfdfdf;
  color: #506382;
}
.blue-text {
  color: #506382;
}
.service-tag {
  font-size: 18px;
}
.service-header {
  font-weight: 800;
  font-size: 30px;
  text-transform: uppercase;
}
.features {
  font-size: 18px;
}
.feature-top {
  font-size: 37px;
}
.feature-bottom {
  margin-top: -10px;
  font-size: 30px;
}
.register-sidebar {
  padding-top: 40px;
  background: #374156;
  color: #ffffff;
  margin-top: -16px;
  margin-bottom: -16px;
}
ul.features {
  margin-left: 0px;
  list-style: none;
  padding-left: 15px;
}

li.feature {
  padding-left: 30px;
  padding-right: 15px;
  padding-bottom: 5px;
  padding-top: 5px;
  background-position: center left;
  background-image: url("/img/onboard/check-green.png");
  background-repeat: no-repeat;
}
</style>
